
<div class="row">
    <div class="col-6">
        <div class="row">
            <div class="col-12">
                <span><h5 style="margin-top: 12px;margin-left: 21px;">File Number : {{file_details.file_number}}</h5></span>
            </div>
        </div>
    </div>
    <div class="col-6 text-right">
        <button type="button" class="close cl" style="color: black;" (click)="back()">&times;</button>
    </div>
</div>
<div class="row mt-2">
    <div class="col-6">
        <div class="div_header">
         <h6 class="text_sty">File Details</h6>
         <hr>
          <div class="inner_div mt-3">
            <div class="row mt-2">
                <div class="col-5">File Number</div>:
                <div class="col-6 text-right">{{file_details.file_number}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">File Date</div>:
                <div class="col-6 text-right">{{ file_details.file_date | date: 'yyyy-MM-dd' }}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">LDA Letter Number</div>:
                <div class="col-6 text-right">{{file_details.lda_letter_number}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Applicant Name</div>:
                <div class="col-6 text-right">{{file_details.party_name}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-7">Applicant Father's Name/Husband's Name </div>:
                <div class="col-4 text-right">{{file_details.party_father_name}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Applicant Mobile Number</div>:
                <div class="col-6 text-right">{{file_details.party_mobile}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Applicant Email ID</div>:
                <div class="col-6 text-right">{{file_details.party_email}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Applicant Address</div>:
                <div class="col-6 text-right">{{file_details.address}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-7">All Floors Building area(In Square meter)</div>:
                <div class="col-4 text-right">{{file_details.floor_buld_area}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Total Area(In Square meter)</div>:
                <div class="col-6 text-right">{{file_details.total_area}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-11">As per the Presented building map (In Square meter)</div>
                <!-- <div class="col-6 text-right"></div> -->
            </div> 
            <div class="row mt-2">
                <div class="col-5">Front Setback </div>:
                <div class="col-6 text-right">{{file_details.front_stack}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Side Setback Left </div>:
                <div class="col-6 text-right">{{file_details.side_stack_l}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Side Setback Right </div>:
                <div class="col-6 text-right">{{file_details.side_stack_r}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Rare Set Back</div>:
                <div class="col-6 text-right">{{file_details.rare_stack}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Khasra No.</div>:
                <div class="col-6 text-right">{{file_details.khasra_no}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Plot No. </div>:
                <div class="col-6 text-right">{{file_details.plot_no}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Zone</div>:
                <div class="col-6 text-right">{{file_details.zone}}</div>
            </div> <div class="row mt-2">
                <div class="col-5">Village</div>:
                <div class="col-6 text-right">{{file_details.village}}</div>
            </div> 
            <div class="row mt-2">
                <div class="col-5">Tehsil</div>:
                <div class="col-6 text-right">{{file_details.tehsil}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Address(for area which NOC is required)</div>:
                <div class="col-6 text-right">{{file_details.addr_noc}}</div>
            </div>
            <div class="row mt-2">
                <div class="col-5">Do the address comes under the *89 village list</div>:
                <div class="col-6 text-right">{{file_details.under_village}}</div>
            </div>
            <br>
          </div>
          <br>
        </div>
        
        <div class="div_header mt-4">
        <div class="borderr" *ngFor="let item of notesheet_desc; let i = index">
         <h6 class="text_sty" >{{i+1}}.Notsheet</h6>
         <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
            <div class="col-12">
                <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
            </div>
         </div> -->
         <hr>
          <div class="inner_div mt-3">
                <div class="notesheet_header font-weight-bold" [class.hindi_text]="item['lang']=='Hindi'" [innerHTML]="item.desc.header"><br>
                </div>
                <div class="body" [class.hindi_text]="item['lang']=='Hindi'" [innerHTML]="item.desc.body" ></div>
                <div class="footer" [class.hindi_text]="item['lang']=='Hindi'" [innerHTML]="item.desc.footer"></div>
                <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->
                <div style="color: red;font-size: bold;text-align: right;">
                    ({{UserObj[item['user_id']]}} - {{item['role']}}) 
                 </div>
            </div>
            <br>
          </div>
          <br>
        </div>





        


    </div>
    <!-- <div class="col-1">
        <div class="vl"></div>
    </div> -->
    <div class="col-6">
        <div class="div div_header2">
        <h6 class="text_sty">Supporting Document</h6>
        <hr>
        <div class="row " *ngFor="let item of supp_doc; let i = index">
           <div class="col-12 text_sty" (click)="view_correspondence(item.supp_doc_name)"><p class="hov_eff">{{i+1}} . {{item.supp_doc_name}}</p></div>
           <!-- <div class="col-5">{{item.notesheet_id}}</div>
           <div class="col-6"></div> -->
        </div>
    </div>
    <div class="div div_header2 mt-4">
        <h6 class="text_sty"> Document</h6>
        <hr>
        <div class="row " *ngFor="let item of adding_doc; let i = index">
           <div class="col-12 text_sty" (click)="view_correspondence(item.doc_name)"><p class="hov_eff">{{i+1}} . {{item.doc_name}}</p></div>
           <!-- <div class="col-5">{{item.notesheet_id}}</div>
           <div class="col-6"></div> -->
        </div>
    </div>
    </div>

 

<!-- <div class="col-1"></div> -->
</div>
<br><br><br>

